import * as React from 'react'
import { FC } from 'react'

import { DialogToolbar } from '@user/components/TopToolbar/DialogToolbar'
import { EmbeddedFormWrapper } from './EmbeddedFormWrapper'
import { FormActions } from './typings'
import { FM_FORM_STATUSES } from '@user/store/agreements/typings'
import { TransitionProps } from '@mui/material/transitions'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" ref={ref} {...props} />
})

interface Props {
  action: FormActions
  formId: number
  onClose: () => void
  open: boolean
  onFormStatusChange?: (status: FM_FORM_STATUSES | undefined) => void
}

export const EmbedFormManagerDrawer: FC<Props> = (props: Props) => {
  const { action, formId, open, onClose, onFormStatusChange } = props

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <DialogToolbar>
        <Button
          variant="contained"
          color="secondary"
          onClick={onClose}
          data-test-id="close-form-manager-button"
        >
          Close Form Manager
        </Button>
      </DialogToolbar>

      <EmbeddedFormWrapper
        action={action}
        formId={formId}
        onClose={onClose}
        onStatusChange={onFormStatusChange}
        title={action == FormActions.Edit ? undefined : 'Send Notification'}
      />
    </Dialog>
  )
}

EmbedFormManagerDrawer.displayName = 'EmbedFormManagerDrawer'
